import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box } from '@mui/material';
import { COLORS,TYPOGRAPHY } from "../constants/color";

const MarkdownRenderer = ({ content, sx = {} }) => {
    if (!content) return null;
    
    return (
        <Box sx={{
            '& h1, & h2, & h3, & h4, & h5, & h6': { 
                color: COLORS.PRIMARY, 
                mt: 2, 
                mb: 1,
           ...TYPOGRAPHY.BODY_STANDARD       
            },
            '& h1': { fontSize: '1.4em' },
            '& h2': { fontSize: '1.3em' },
            '& h3': { fontSize: '1.1em' },
            '& p': { 
                color: COLORS.PRIMARY, 
                mb: 1,
                lineHeight: 1.6 
            },
            '& ul, & ol': { 
                color: COLORS.PRIMARY, 
                ml: 2,
                mb: 1 
            },
            '& li': { mb: 0.5 },
            '& strong, & b': { 
                color: COLORS.SECONDARY,
                fontWeight: 600 
            },
            '& em, & i': { fontStyle: 'italic' },
            '& u': { textDecoration: 'underline' },
            ...sx
        }}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
            </ReactMarkdown>
        </Box>
    );
};

export default MarkdownRenderer;